import { userConstants } from '../_constants';
import { alertActions } from './alert.actions';
import { APIcallFunction, headerForPrivateAPI, headerForPublicAPI, logoutFunction } from '../_helpers';



export const userActions = {
    login,
    logout,
    saveAccess,
    getProfile
};

function login(data, navigate) {
    const credential = {
        header: headerForPublicAPI,
        method: "POST",
        body: data ?? {},
        endPoint: '/admin/login',
    };
    return (dispatch) => {
        dispatch(request({ data }));


        APIcallFunction(credential)
            .then(
                (user) => {
                    window.sessionStorage.setItem("adminuser", JSON.stringify(user.data));
                    dispatch(success(user));
                    dispatch(alertActions.success("success."))
                    dispatch(getProfile({}));
                    if (navigate) {
                        navigate('/app/dashboard');
                    }
                },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user }; }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user }; }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error }; }
}

function getProfile(data) {
    const credential = {
        header: headerForPrivateAPI(),
        method: "POST",
        body: data ?? {},
        endPoint: '/admin/profile',
    };
    return (dispatch) => {
        dispatch(request({ data }));


        APIcallFunction(credential)
            .then(
                (user) => {
                    dispatch(success(user));
                },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(user) { return { type: userConstants.GET_PROFILE_REQUEST, user }; }
    function success(user) { return { type: userConstants.GET_PROFILE_SUCCESS, user }; }
    function failure(error) { return { type: userConstants.GET_PROFILE_FAILURE, error }; }
}

function saveAccess(data) {
    return (dispatch) => {
        dispatch(request({ data }));
        function request() { return { type: userConstants.userAccess, data }; }
    }
}

function logout() {
    logoutFunction();
    return { type: userConstants.LOGOUT };
}
